import _ from 'lodash'

export default (form, baseName) => _.get(form, `values.${baseName}.enabled`)
